<template>
  <FormulateInput
    type="text"
    :label="label"
    v-model="input_value"
    :validation="validation"
    :input-class="disabled ? 'disabled' : 'editMode'"
    :disabled="disabled"
    :validation-messages="{
      required: 'Veld is verplicht',
      min: ({ args }) => `Waarde moet hoger zijn dan ${args}`,
      max: ({ args }) => `Waarde moet lager zijn dan ${args}`
    }"
  />
</template>

<script>
export default {
  name: "InputInteger",
  props: ["label", "value", "options", "name", "disabled"],
  data() {
    return {
      input_value: this.value,
      validation: [["number"]]
    };
  },
  methods: {
    parseValidators: function() {
      if ("minimum" in this.options) {
        this.validation.push(["min", this.options.minimum]);
      }
      if ("maximum" in this.options) {
        this.validation.push(["max", this.options.maximum]);
      }
    }
  },
  created: function() {
    this.parseValidators();
  },
  watch: {
    input_value(value) {
      this.$emit("FlexpropDataChange", {
        key: this.name,
        value: parseInt(value)
      });
    }
  }
};
</script>
